
<div class="w100 h100"
>
    <canvas #Chart></canvas>
</div>
